import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'atlassian-navigation.profile.tooltip',
		defaultMessage: 'Your profile and settings',
		description: 'Tooltip for profile icon in top bar navigation, shown when user is logged in',
	},
});
